// extracted by mini-css-extract-plugin
export default {"ribbon-message":"RibbonMessage_ribbon-message__LbPU1","content-container":"RibbonMessage_content-container__bQR35","text-container":"RibbonMessage_text-container__unsnZ"};